import { Component, Inject, Injectable } from '@angular/core';
import { ForumApiService } from 'src/app/service/forum.api.service';
import { HttpClient } from '@angular/common/http';
import { APP_SETTINGS, AppSettings } from 'src/app/settings';
import { EncryptionService } from 'src/app/service/encryption.service';
import { StorageService } from '../service/storage.service';
import { Meta } from '@angular/platform-browser';
import { BottomsheetModalComponent } from './bottomsheet-modal/bottomsheet-modal.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../service/data.service';
import { ConstantService } from '../service/constant.service';
@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.less'],
})
export class ForumComponent { 
  
  categoryId = [];  
  sortedArray = [];
  mainBaseArray = [];
  questionsArray = [];
  finalQuestionArray = [];
  titleArrayForKeywords = [];

  viewChange = this.constantService.viewLess;
  
  questionCount: number;

  isLoggedIn: string;
  mainCategory: string;
  portalNumber: string;
  subCategory: string;
  quaestionsArrayTitle:string;

  panelOpenState = false;
  showLoader: boolean;

  constructor(
    private http: HttpClient,
    @Inject(APP_SETTINGS) private settings: AppSettings,
    private encryptionService: EncryptionService,
    private forumApiService: ForumApiService,
    private storageService: StorageService,
    private router: Router,
    private meta: Meta,
    private _bottomSheet: MatBottomSheet,
    private titleService: Title,
    private route: ActivatedRoute,
    private dataService: DataService,
    private constantService: ConstantService,
  ) { }  

  ngOnInit(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    this.getPortalId();
    this.addMetaTag();
    this.titleService.setTitle(this.constantService.forumPageTitle);
  }

  addMetaTag(): void {
    this.meta.updateTag({ name: this.constantService.robots, content: this.constantService.forumPageRobotContent });
    this.meta.updateTag({ name: this.constantService.description, content: this.constantService.forumPageDescription});
  }

  async getPortalId(): Promise<void> {
    try {
      const orgId = this.encryptionService.decryptUsingAES_256(this.settings.orgId);

      await this.forumApiService
        .getPortalId(orgId)
        .then(async (getPortalIdResponse) => {
          if (getPortalIdResponse.data.length > 0) {
            for (let i = 0; i < getPortalIdResponse.data.length; i++) {
              if (getPortalIdResponse.data[i].name == '5paisa') {
                this.portalNumber = getPortalIdResponse.data[i].portalId;
                this.storageService.setItem(
                  this.constantService.portalId,
                  this.encryptionService.encryptUsingAES_256(this.portalNumber)
                );
              }
            }
          }         
        });
          this.knowledgeBase();
    } catch (e) {
      console.group('Error Occured in getPortalId : ', e);
    }
  }

  async knowledgeBase(): Promise<void> {
    try {
      const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
      const include = this.constantService.knowledgeBaseRequestInclude;
      await this.forumApiService.knowledgeBase(include, portalId).then(async (knowledgeBaseResponse) => {
          for(let i=0; i<knowledgeBaseResponse.child.length; i++){
            this.mainBaseArray[i] = knowledgeBaseResponse.child[i];
            this.categoryId[i] = this.mainBaseArray[i].id;
            this.titleArrayForKeywords[i] = this.mainBaseArray[i].name;
          }
          this.dataService.sendData(this.mainBaseArray);
          var str = this.titleArrayForKeywords.join(", ");
          this.meta.updateTag({ name: this.constantService.keywords, content: str }); 
      });
      this.frequentlyAskedQuestions();
    } catch (e) {
      console.group('Error Occured in knowledgeBase : ', e);
    }
  }

  async frequentlyAskedQuestions(): Promise<void> {    
    try {
      this.showLoader = true;
        const portalId = this.encryptionService.decryptUsingAES_256(this.storageService.getItem(this.constantService.portalId));
        const from = this.constantService.faqRequestConstant.faqFrom;
        const limit = this.constantService.faqRequestConstant.faqLimit;
        const sortBy = this.constantService.faqRequestConstant.faqSortBy;
        const locale = this.constantService.faqRequestConstant.faqlocale;

        for(let i=0; i<this.categoryId.length; i++) {
          await this.forumApiService.articalList(portalId, this.categoryId[i], from, limit, sortBy, locale).then(async (getArticalListResponse) => {
            this.questionsArray[i] = getArticalListResponse.data;
          });
        }
        
        for(let j=0; j<this.questionsArray.length; j++){
          this.sortedArray[j] = this.questionsArray[j].slice(-2);
        }

        this.finalQuestionArray = [].concat(...this.sortedArray);
        this.questionCount = this.finalQuestionArray.length;   
        this.showLoader = false;     
        this.getViewMore(this.constantService.viewLess);
    } catch (e) {
      this.showLoader = false;
      console.group('Error Occured in frequentlyAskedQuestions : ', e);
    }    
  }

  goToKnowledgeBaseComponent(cName: string): void {
    this.router.navigateByUrl(cName);
  }

  goTosubCategoryAnswers(questionId: string, catId: string, questionTitle: string): void {
    this.dataService.data.subscribe((mainCategoryArray) => {
      mainCategoryArray.forEach(mainCat => {
        mainCat.child.forEach(subCat => {
          if(subCat.id == catId){
            this.mainCategory = mainCat.permalink;
            this.subCategory = subCat.permalink;
          }
        });
      });
    });
    this.router.navigate([this.mainCategory + '/' + this.subCategory + '/' + questionTitle], {queryParams: { questionId }});
  }

  getViewMore(viewChange: string) : void {
    if(viewChange == this.constantService.viewLess){
      viewChange = this.constantService.viewMore;
      this.viewChange = this.constantService.viewMore;
    } else {
      viewChange = this.constantService.viewLess;
      this.viewChange = this.constantService.viewLess;
    }

    if(this.viewChange == this.constantService.viewLess || viewChange == this.constantService.viewLess){
      this.finalQuestionArray = [].concat(...this.sortedArray);
    } else if(this.viewChange == this.constantService.viewMore || viewChange == this.constantService.viewMore){
      this.finalQuestionArray = this.finalQuestionArray.slice(0, 2); 
    }
  }

  goToCreateTicket(): void {
    try {
      this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
      if(this.isLoggedIn == this.constantService.yes) {
        this.router.navigateByUrl(this.constantService.navigationComponentPage.createTicket);
      } else {
        this._bottomSheet.open(BottomsheetModalComponent, {
          data: { message: this.constantService.notLoggedInMessage }
        });
      }   
    } catch (e) {
      console.log('Error in goToCreateTicket method - ',e);
    }     
  }

  letsChat(): void {
    this.isLoggedIn = this.storageService.getItem(this.constantService.isLoggedIn);
    if(this.isLoggedIn == this.constantService.yes) {
      window.location.href = this.constantService.letsChatBotLink;
    } else {
      this._bottomSheet.open(BottomsheetModalComponent, {
        data: { message: this.constantService.notLoggedInMessage }
      });
    }    
  }

}